import React from 'react';
import { eventTypes } from '../constants/eventTypes';

interface EventTypeSelectProps {
  selectedTypes: string[];
  onChange: (types: string[]) => void;
  error?: string;
  touched?: boolean;
}

const EventTypeSelect: React.FC<EventTypeSelectProps> = ({
  selectedTypes,
  onChange,
  error,
  touched
}) => {
  const handleTypeToggle = (type: string) => {
    const newTypes = selectedTypes.includes(type)
      ? selectedTypes.filter(t => t !== type)
      : [...selectedTypes, type];
    onChange(newTypes);
  };

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        Event Types Offered
      </label>
      <div className="flex flex-wrap gap-2">
        {eventTypes.map((eventType) => (
          <button
            key={eventType.type}
            type="button"
            onClick={() => handleTypeToggle(eventType.type)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
              selectedTypes.includes(eventType.type)
                ? 'bg-muted-grey text-white hover:bg-muted-grey/80 hover:shadow-[5px_5px_0_-2px_theme(colors.muted.darkGrey)]'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:shadow-[5px_5px_0_-2px_theme(colors.muted.grey)]'
            }`}
          >
            {eventType.label}
          </button>
        ))}
      </div>
      {touched && error && (
        <p className="text-muted-error text-sm mt-1">{error}</p>
      )}
    </div>
  );
};

export default EventTypeSelect; 